// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"266":"02cd2172df130ba29fdc85561ef75877","284":"413b83843c409412b45a0c2692fc674f"}[chunkId] + ".js";
};